import React, {Component} from 'react';
import {Label} from 'semantic-ui-react';
import connect from "react-redux/es/connect/connect";
import {selectRecipe} from "../../actions/RecipeSelectActions";
import {openModalProductStock} from "../../actions/ModalProductStockActions";

class RecipeStock extends Component {
    handelClick = () => {
        this.props.selectRecipe(this.props);
        this.props.openModalProductStock({id: this.props.id, name: this.props.name, is_open:true})
    };

    render() {
        return <Label as='a' color='orange' onClick={this.handelClick}>{`${this.props.count_stock} Porciones`}</Label>;
    }
}

function mapDispatchToProps(dispatch){
    return {
        selectRecipe(data) {
            dispatch(selectRecipe(data));
        },
        openModalProductStock(data){
            dispatch(openModalProductStock(data))
        },
    }
}


export default connect(
    null,
    mapDispatchToProps
)(RecipeStock)


// WEBPACK FOOTER //
// ./src/components/inventories/RecipeStock.js